import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import store from "../../../../_services/store";
import { DropContainer, Label, ValidateButton } from "../components";
import { useNavigate } from "react-router-dom";
import Modal from "../modal";
import { getQuizzQuestions } from "../../../../_services/api/quizz";
import { useWindowResize } from "../../../../_hooks/use-window-resize";

const modalDefaultProps = {
  isOpen: false,
  title: "",
  content: "",
  btn1: {
    label: "",
    func: () => { }
  }
}

const QuizzQuestions = observer(() => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<TQuizzModalProps>(modalDefaultProps);
  const [userAnswers, setUserAnswers] = useState<(string | 0 | 1 | undefined)[]>([]);
  const { isMobile } = useWindowResize();

  if (store.quizzes === null || store.currentQuestion === null) {
    return <p>No Quizzes or no questions, should not happen</p>;
  }

  const currentQuestion = store.currentQuestion.data;
  if (!currentQuestion) return <></>;

  console.log(currentQuestion);
  const { quizzes, quizzId } = store;

  useEffect(() => {
    getQuizzQuestions({ id: quizzId, lg: store.currentLanguage }).then(
      (res) => {
        store.setCurrentQuestion({ id: 0, data: res[0] });
        store.setQuestionIndex(0);
        store.setResQuiz(res);
      }
    );
    return () => { };
  }, []);

  const goNext = () => {
    const nextIndex = store.questionIndex + 1;
    //if there is a next another question
    if (store.resQuiz?.[nextIndex]) {
      store.setCurrentQuestion({
        id: nextIndex,
        data: store.resQuiz[nextIndex],
      });
      store.setQuestionIndex(nextIndex);
    } else {
      // check if answers are all good
      const isAllGood: boolean = userAnswers.every(e => e == 1);
      if (isAllGood) {
        setModal({
          isOpen: true,
          title: "Bravo",
          content: "Vous n’avez fait aucune faute",
          btn1: {
            label: "Passer au suivant",
            func: () => { 
              store.sendQuizzResults();
              navigate(-1);
            }
          }
        });
      }
      else {
        setModal({
          isOpen: true,
          title: "Deuxième chance",
          content: "Vous avez fait des erreurs, souhaitez-vous valider ou réessayer ?",
          btn1: {
            label: "Valider",
            func: () => { 
              store.sendQuizzResults();
              navigate(-1);
            }
          },
          btn2: {
            label: "Réessayer",
            func: () => { retry() }
          }
        });
      }
    }
  };

  function retry() {
    setModal({ ...modal, ...{ isOpen: false } });
    setUserAnswers([]);
    store.setQuestionIndex(0);
  }

  function handleClick(res: TResponse) {
    const answers = [...userAnswers, res.is_the_answer]
    setUserAnswers(answers);

    const { question_id } = currentQuestion.question_response;
    store.setQuizzResp({
      id: store.quizzId,
      val: {
        [question_id]: {
          val: +res.id,
          validated: res.is_the_answer || 0,
        },
      },
    });

    goNext();
  }

  return (
    <div>
      <DropContainer>
        <Label style={{ maxWidth: isMobile ? '320px' : '600px' }}>{currentQuestion.question_response.question}</Label>
      </DropContainer>

      {currentQuestion.question_response.response.map(e =>
        <ValidateButton
          onClick={() => handleClick(e)}
          style={{ margin: '16px auto' }}
          key={e.content}
        >
          {e.content}
        </ValidateButton>
      )}

      <Modal
        isOpen={modal.isOpen}
        title={modal.title}
        content={modal.content}
        btn1={modal.btn1}
        btn2={modal.btn2}
      />
    </div>
  )
})

export default QuizzQuestions;